export const STUDENT_TEST_BOOK = 'STUDENT_TEST_BOOK';
export const SCORING_WORKSHEET = 'SCORING_WORKSHEET';
export const STUDENT_TEST_BOOK_PREVIEW = 'STUDENT_TEST_BOOK_PREVIEW';
export const SCORING_GUIDE = 'SCORING_GUIDE';
